import { render, staticRenderFns } from "./JEditorDyn.vue?vue&type=template&id=5ef60818&scoped=true"
import script from "./JEditorDyn.vue?vue&type=script&lang=js"
export * from "./JEditorDyn.vue?vue&type=script&lang=js"
import style0 from "./JEditorDyn.vue?vue&type=style&index=0&id=5ef60818&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef60818",
  null
  
)

export default component.exports